import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import HttpService from '../../../hooks/Https-services';
import { API_ROUTES, dateFormat, timeFormat } from '../../../utils/constant';
import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  IconButton,
  Pagination,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material';
import moment from 'moment';
import Iconify from '../../../components/iconify';

function BroadcastNotificationUsers() {
  const { userId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);
  const [currentUser, setCurrentUser] = useState<any>(null);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [totalPages, setTotalPages] = React.useState(10);
  const itemsPerPage = 10;
  const fetchUserById = React.useCallback(async () => {
    try {
      const query: any = {
        page: currentPage,
        limit: itemsPerPage,
      };
      setLoading(true);
      const response = await HttpService.get(
        API_ROUTES.BroadcastNotificationUserByid + `/${userId}`
      );
      setCurrentUser(response?.data?.data?.list);
      setTotalPages(response.data.data.totalPages);
      setLoading(false);
    } catch (error: any) {
      console.error('Error fetching teams list:', error);
      setLoading(false);
    }
  }, [currentPage]);
  React.useEffect(() => {
    fetchUserById();
  }, [fetchUserById]);

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setCurrentPage(page); // Update the current page
  };

  function Row(props: { row: any }) {
    const { row } = props;
    console.log(row);
    return (
      <React.Fragment>
        <TableRow>
          <TableCell sx={{ '&:hover': { color: 'orange', cursor: 'pointer' } }}>
            {row?.user?.name}
          </TableCell>

          <TableCell sx={{ '&:hover': { color: 'orange', cursor: 'pointer' } }}>
            {row?.createdAt ? (
              <Stack direction={'column'}>
                <Typography variant="body2">
                  {moment(row?.createdAt).format(`${dateFormat}`)}
                </Typography>
                <Typography variant="body2">
                  {moment(row?.createdAt).format(`${timeFormat}`)}
                </Typography>
              </Stack>
            ) : (
              '-'
            )}
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }
  return (
    <>
      {' '}
      <TableContainer component={Paper}>
        <Table aria-label="collapsible table">
          <TableHead>
            <TableRow>
              <TableCell align="left">Name</TableCell>
              <TableCell align="left">Read At</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Array.isArray(currentUser) &&
              currentUser.map((data: any) => <Row key={data.id} row={data} />)}
          </TableBody>
        </Table>
      </TableContainer>
      {/* Pagination Component */}
      <Box display="flex" justifyContent="center" my={2}>
        <Pagination
          count={totalPages} // Total number of pages
          page={currentPage} // Current page
          onChange={handlePageChange} // Handle page change
          color="primary"
        />
      </Box>
      {/* Backdrop with CircularProgress for loader */}
      <Backdrop
        sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}

export default BroadcastNotificationUsers;
